import Vue from './utils/global'
import App from './App.vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import "@wangeditor/editor/dist/css/style.css"
import router from './router'
import store from './store'
import filters from './utils/filters'
import "@/assets/css/recess.css"

//全局注入
Vue.config.productionTip = false
Vue.mixin(filters)
Vue.use(ElementUI)

//创建实例
new Vue({
  router,
  store,
  render: function (h) { return h(App) }
}).$mount('#app') 